import React from 'react';
import { Typography } from '../Typography/Typography';
import classNames from 'classnames/bind';
import { Close } from '../../assets/icons/Close';
import styles from './Banner.module.scss';

const cx = classNames.bind(styles);

export interface IBanner {
  text: string;
  backgroundColor: 'grape';
  textColor?: 'primary' | 'secondary';
  closeBanner?: () => void;
}

const Banner = ({ text, backgroundColor, textColor = 'secondary', closeBanner }: IBanner) => {
  return (
    <div
      className={cx('banner', {
        [`banner-${backgroundColor}`]: backgroundColor,
      })}
    >
      <Typography size="S" color={textColor}>
        {text}
      </Typography>
      {closeBanner && (
        <button type="button" data-testid="banner-close-icon" onClick={closeBanner}>
          <Close className={cx('close-icon', 'white')} />
        </button>
      )}
    </div>
  );
};

export default Banner;
